"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItalicsIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _italic = _interopRequireDefault(require("../../../../../../images/italic.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ItalicsIcon = function ItalicsIcon(_ref) {
  var italicState = _ref.italicState,
    resetIconState = _ref.resetIconState,
    setItalicState = _ref.setItalicState;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "action-icon",
    onClick: function onClick() {
      resetIconState();
      setItalicState(!italicState);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: italicState ? 'bordered' : 'simple',
    src: _italic.default,
    alt: "Italic"
  }));
};
exports.ItalicsIcon = ItalicsIcon;